<template>
  <div class="mt--4 pl-5 pr-5 pb-5">
    <h1 class="pb-4">
      Disclosure
    </h1>
    <p>
      These sample templates are not legal advice and by using them you agree to
      this disclaimer. The materials below are for informational purposes only
      and do not constitute advertising, a solicitation or legal advice. You
      should consult independent legal advice before publishing these
      agreements. You should read the generated information with care and
      modify, delete or add all and any areas as necessary. Use of, access to or
      transmission of such materials and information or any of the links
      contained herein is not intended to create, and receipt thereof does not
      constitute formation of, an attorney-client relationship between Moolah
      and the user or browser. You should not rely upon this information for any
      purpose without seeking legal advice from a licensed attorney in your
      state or province. The information contained is provided only as general
      information and may or may not reflect the most current legal
      developments; accordingly, information is not promised or guaranteed to be
      correct or complete. Moolah expressly disclaims all liability in respect
      to any actions taken or not taken based on any or all of the contents of
      the provided template.<br />
      <br />
    </p>
    <h3 class="strong pb-3">
      Do you want to use our default {{ name }} template?
    </h3>
    <b-form-group>
      <b-button variant="danger" @click="$emit('dontAgree')"
        >No. I will use my own template</b-button
      >
      <b-button variant="success" @click="$emit('agreed')">Yes</b-button>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
    };
  },
  props: { name: { default: "terms and conditions", type: String } },
  methods: {
    k() {
      if (this.selected == "AGREED") this.$emit("agreed");
      else this.$emit("dontAgree");
    },
  },
};
</script>

<style></style>
